import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

interface AuthWrapperProps {
  isAuthenticated: boolean;
  // isLoading: boolean;
  // error?: Error | null;
}

export function AuthWrapper({
  isAuthenticated,
}: AuthWrapperProps) {
  // if (isLoading) {
  //   return (
  //     <div className="min-h-screen flex items-center justify-center bg-bg">
  //       <Loader2 className="h-8 w-8 text-primary animate-spin" />
  //     </div>
  //   );
  // }

  // if (error) {
  //   return (
  //     <div className="min-h-screen flex flex-col items-center justify-center bg-bg">
  //       <div className="text-center">
  //         <h1 className="text-2xl font-semibold text-dark-blue mb-2">
  //           Session Expired
  //         </h1>
  //         <p className="text-dark-grey mb-4">
  //           Please log in again to continue.
  //         </p>
  //         <a
  //           href="/login"
  //           className="text-primary hover:underline"
  //         >
  //           Back to Login
  //         </a>
  //       </div>
  //     </div>
  //   );
  // }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}